var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1693 0.102539C12.1181 0.175248 10.8894 0.848112 10.1734 1.72432C9.52028 2.51918 8.98298 3.69978 9.19248 4.8471C10.341 4.88284 11.5278 4.19395 12.2154 3.30296C12.8587 2.47359 13.3455 1.30039 13.1693 0.102539Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3243 6.71788C16.315 5.45226 14.8965 4.71777 13.557 4.71777C11.7885 4.71777 11.0405 5.5644 9.81184 5.5644C8.54498 5.5644 7.58251 4.72024 6.05316 4.72024C4.55092 4.72024 2.95133 5.63834 1.9371 7.20836C0.511269 9.4192 0.755275 13.5759 3.06594 17.1165C3.89285 18.3833 4.99703 19.8079 6.44135 19.8203C7.7267 19.8326 8.08901 18.9958 9.83032 18.9872C11.5716 18.9773 11.9019 19.8314 13.1848 19.8178C14.6303 19.8067 15.7949 18.2281 16.6218 16.9612C17.2146 16.053 17.4352 15.5958 17.8948 14.5704C14.5515 13.2974 14.0154 8.543 17.3243 6.71788Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.bedd83d3.svg";
export { ForwardRef as ReactComponent };